
import react, { PureComponent } from "react";
import { SurveyContext } from '../surveycontext';

class SurveyResult extends PureComponent {

    state = {
        result: null
    }

    componentDidMount() {
        this.fetchSurveyResultAsync()

    }

    async fetchSurveyResultAsync() {
        const surveyResult = await this.context.getSurveyResultAsync();
        console.log(surveyResult)
        this.setState({ 'result': surveyResult });
    }

    render() {
        const { result } = this.state;

        return (
            result &&
            <React.Fragment>
                <div className='surveyresult' dangerouslySetInnerHTML={{ __html: result.scoreText }} />
                <div className='surveyresult' dangerouslySetInnerHTML={{ __html: result.resultText }} />
            </React.Fragment>
        );
    }

}

SurveyResult.contextType = SurveyContext;
export default SurveyResult;